import styles from './SbRespTradeOnApprovalLoadingBanner.scss';

export const SbRespTradeOnApprovalLoadingBanner = () => <div className={styles.loadingBanner} />;
